export default [
  { to: 'vuxen', title: 'Vuxen' },
  { to: 'barn', title: 'Barn' },
  { to: 'preparathandbok', title: 'Preparathandbok' },
  { to: 'allmant', title: 'Arkiv' },
  // TODO: Web app doesn't support categories with URL https://gitlab-ee.softwerk.se/eir/eir/issues/280
  // { to: 'retts', title: 'RETTS' }
];
